// AdminCompanyPage.jsx
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const AdminCompanyPage = () => {
  const [companyName, setCompanyName] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [personInCharge, setPersonInCharge] = useState('');
  const [fleetSize, setFleetSize] = useState('');
  const [selectedShips, setSelectedShips] = useState([]);
  const [ships, setShips] = useState([]);
  const [sectionOpen, setSectionOpen] = useState(true);

  // Fetch ships from the Ships database
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => setShips(data))
      .catch(error => console.error('Error fetching ships:', error));
  }, []);

  const toggleSection = () => {
    setSectionOpen(prev => !prev);
  };

  const handleShipChange = (e) => {
    const options = e.target.options;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }
    setSelectedShips(selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const companyData = {
      companyName,
      address,
      phoneNumber,
      personInCharge,
      fleetSize,
      ships: selectedShips, // Array of ship IDs
    };

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/companies`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(companyData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Company saved successfully:', data);
        // Optionally reset the form fields
        setCompanyName('');
        setAddress('');
        setPhoneNumber('');
        setPersonInCharge('');
        setFleetSize('');
        setSelectedShips([]);
      })
      .catch(error => console.error('Error saving company:', error));
  };

  return (
    <div className="container-fluid px-4 py-3">
      <h2 className="mb-4">Admin - Company</h2>
      <form onSubmit={handleSubmit}>
        {/* Company Details Section */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center bg-light p-2 border">
            <h4 className="mb-0">Company Details</h4>
            <button type="button" className="btn btn-link" onClick={toggleSection}>
              {sectionOpen ? '▼' : '►'}
            </button>
          </div>
          {sectionOpen && (
            <div className="p-3 border border-top-0">
              {/* Row 1: Company Name & Person In Charge */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="companyName" className="form-label">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="companyName"
                    name="companyName"
                    placeholder="Enter company name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="personInCharge" className="form-label">Person In Charge</label>
                  <input
                    type="text"
                    className="form-control"
                    id="personInCharge"
                    name="personInCharge"
                    placeholder="Enter person in charge"
                    value={personInCharge}
                    onChange={(e) => setPersonInCharge(e.target.value)}
                  />
                </div>
              </div>
              {/* Row 2: Fleet Size */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="fleetSize" className="form-label">Fleet Size</label>
                  <input
                    type="number"
                    className="form-control"
                    id="fleetSize"
                    name="fleetSize"
                    placeholder="Enter fleet size"
                    value={fleetSize}
                    onChange={(e) => setFleetSize(e.target.value)}
                  />
                </div>
              </div>
              {/* Row 3: Address & Phone Number */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="address" className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                    placeholder="Enter address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="Enter phone number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>
              {/* Row 4 - Assign Ships */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="ships" className="form-label">Assign Ships</label>
                  <select
                    multiple
                    className="form-select"
                    id="ships"
                    name="ships"
                    value={selectedShips}
                    onChange={handleShipChange}
                    size="10" // Shows more options at once
                  >
                    {ships.map((ship) => (
                      <option key={ship._id} value={ship._id}>
                        {ship.vesselName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
        <button type="submit" className="btn btn-primary">Save Company Details</button>
      </form>
    </div>
  );
};

export default AdminCompanyPage;
